import React from 'react';
import MetricsCard from './MetricsCard';

/**
 * Company metrics dashboard displaying total, active, and inactive counts
 */
const CompanyMetrics = ({ metrics }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <MetricsCard
        title="Total Companies"
        value={metrics?.total}
        icon="building"
        color="blue"
        trend="neutral"
        trendValue={0}
      />
      <MetricsCard
        title="Active Companies"
        value={metrics?.active}
        icon="check"
        color="green"
        trend="neutral"
        trendValue={0}
      />
      <MetricsCard
        title="Inactive Companies"
        value={metrics?.inactive}
        icon="x"
        color="red"
        trend="neutral"
        trendValue={0}
      />
    </div>
  );
};

export default CompanyMetrics;